<template>
  <div>
    <div class="row mb-3">
      <div class="col-md-12">
        Product Category : 
        <select v-model="selectedCategory" @change="changeCategory($event)">  
          <option value="">-</option>
          <option v-for="(item, key) in productCategories" :key="key" :value="item.id">{{ item.name }}</option>
        </select>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <DataTable
          ref="datatable"
          :settings="datatable.settings"
          :dataColumns="datatable.columns"
          :dataFeed="datatable.dataFeed"
          :dataHandle="datatable.handle"
          :dataTableHeight="datatable.height"
          :defaultSortBy="datatable.sortBy"
          :defaultOrderBy="datatable.orderBy"
          :allowView="allowView"
          :allowEdit="allowEdit"
          :allowDelete="allowDelete"
          :hasContextMenu="hasContextMenu"
          :customRowStyle="customRowStyle"
          :customFilter="customFilter"
          :usePixel="true"
        >
        <template slot="menuButtons" slot-scope="props">
          <template v-if="props.item && props.item.data">
            <li @click="$refs.datatable.viewItem($event, props.item.data)" v-if="allowView(props.item.data)">View</li>
            <li @click="$refs.datatable.editItem($event, props.item.data)" v-if="allowEdit(props.item.data)">Edit</li>
            <li @click="$refs.datatable.confirmDelete($event, props.item.data)" v-if="allowDelete(props.item.data)">Delete</li>
          </template>
        </template>
        </DataTable>
        <!-- END DATA TABLE -->
        <ImportModule 
            ref="importModule"
            @reload="reload"
            :uploadURL="$root.WebService.product + '/import/upload'" 
            :confirmURL="$root.WebService.product + '/import/confirm'"/>
      </div>
    </div>
  </div>
</template>
<script>

import ImportModule from 'src/components/ImportModule'
import exportData from 'src/global/exportData.js'
import importData from 'src/global/importData.js'

export default {
  components: {
    ImportModule
  },
  data() {
    return {
      pageSettings: {
        pageTitle: 'Product',
        sectionName: 'product',
        sectionIcon: 'fas fa-glass',
        type: 'listing',
        useDefault: false,
        webService: this.$root.WebService.product,
        navigation: [
          { name: 'Product', route: 'product.index' }
        ],
        buttons: [],
        subSidebar: {
          buttons: [
            { name: 'Product List', icon: 'fas fa-file-download', action: () => { this.$router.push({ name: 'product.index' }) } },
            { name: 'Product Categories', icon: 'fas fa-file-download', action: () => { this.$router.push({ name: 'product.category.index' }) } },
          ]
        }
      },
      datatable: {
        settings: {
          sectionName: 'product',
          webService: this.$root.WebService.product,
        },
        dataFeed: null,
        handle: null,
        columns: [],
        defaultColumns: [
          { key: 'part_no', title: 'Part No', type: 'input', width: '330px', value: null },
          { key: 'vendor_short_name', title: 'Vendor', type: 'input', width: '110px', value: null },
          { key: 'ref_no', title: 'Ref No.', type: 'input', width: '110px', value: null },
          { key: 'latest_price', title: 'Unit Price', type: 'input', width: '110px', value: null },
          { key: 'latest_price_date', title: 'Price Date', type: 'datepicker', width: '150px', value: { from: null, to: null }, datafilter: this.$options.filters.dateFormat },
          { key: 'latest_price_terms', title: 'Terms', type: 'input', width: '110px', value: null },
          {key: 'status', title: 'Status', type: 'select', width: '110px', value: null, datafilter: this.$options.filters.capitalize, selectOptions:
            {
              key: 'status', valueKey: 'value', displayKey: 'title', datas: [{ value: 'Ordered', title: 'Ordered' }, { value: 'Standard', title: 'Standard' }, { value: 'Both', title: 'Both' }, { value: 'N/A', title: 'N/A' }]
            }
          },
          //{ key: 'vendor', title: 'Vendor', type: 'input', width: '10%', value: null },
          //{ key: 'ref_no', title: 'Ref No', type: 'input', width: '5%', value: null },
          //{ key: 'vendor', title: 'Vendor', type: 'input', width: '10%', value: null },
          // { key: 'category', title: 'Category', type: 'select', width: '10%', value: null, itemDisplayKey: 'name', selectOptions: { valueKey: 'id', searchKey: 'id', displayKey: 'name', datas: [] } },
          { key: 'created_at', title: 'Created At', type: 'datepicker', width: '150px', datafilter: this.$options.filters.dateFormat, value: { from: null, to: null } },
        ],
        sortBy: null,
        orderBy: 'desc',
        width: '100%',
        height: '70vh',
      },
      datas: [],
      filteredDatas: [],
      selectedProduct: null,
      productCategories: null,
      selectedCategory: '',
      customFilter: null,
      exportFunction: {
        url: this.$root.WebService.product + '/export',
        fileName: 'ExportProduct'
      },
    }
  },
  watch: {
    $route(to, from) {
      this.$emit('setPageHeader', this.pageSettings)
    },
    selectedCategory: {
      immediate: false,
      handler(id) {
        
        let category = this.productCategories.find(item => item.id == id)

        if( category ) {

          
          this.datatable.dataFeed = {
            method: 'get',
            url: this.pageSettings.webService + '?category=' + category.id
          }

          var columns = this.datatable.defaultColumns.slice()
          
          category.structure.forEach(structure => {
            columns.push(
              { key: 'structure_' + structure.id, title: structure.field_name.en, type: 'input', width: '120px', value: null, 
                customValueDisplay: (item) => {
                  let column = item.datas.find(i => i.product_structure_id == structure.id)
                  if( column )
                    return column.field_value
                }, 
                customItemValue: (item) => {
                  let column = item.datas.find(i => i.product_structure_id == structure.id)
                  if( column )
                    return column.field_value
                }
              }
            )
          })

          this.datatable.columns = columns

        } else {

          //this.datatable.columns = this.datatable.defaultColumns.slice()

        }

        // this.customFilter = {
        //   column: '',
        //   filter: (item) => {
        //     if( !category )
        //       return false
              
        //     return category.id == item.product_category_id
        //   }
        // }

        this.$nextTick(function () {

          this.$refs.datatable.doFilter()
          
        })
      }
    }
  },
  created() {
    this.getProductCategory()
  },
  mounted() {

    if( this.hasPermission('import product') ) this.pageSettings.buttons.push({ name: 'Import', icon: 'fas fa-file-upload', action: this.importData })
    if( this.hasPermission('export product') ) this.pageSettings.buttons.push({ name: 'Export', icon: 'fas fa-file-download', action: this.exportData })
    if( this.hasPermission('create product') ) this.pageSettings.buttons.push({ name: 'Add New Product', icon: 'fas fa-plus', action: this.addItem })

    this.$emit('setPageHeader', this.pageSettings)

    //this.datatable.columns = this.datatable.defaultColumns.slice()

    this.datatable.handle = (res) => this.datas = res.data.data
    // this.datatable.dataFeed = {
    //   method: 'get',
    //   url: this.pageSettings.webService
    // }
  },
  methods: {
    getProductCategory() {
      this.$http
        .get(this.WebService.productCategory)
        .then((response) => {
          let categoryColumn = this.datatable.defaultColumns.find(item => item.key == 'category')
          this.productCategories = response.data.data
          //categoryColumn.selectOptions.datas = this.productCategories

          if( this.$route.params.id ) 
          {
            let catID = this.$route.params.id
            this.selectedCategory = catID
          }

        })
        .catch(null)
        .finally(null)
    },
    changeCategory(event) {
      if( event.target.value )
        this.$router.push({ name: this.pageSettings.sectionName + '.index', params: { id: event.target.value }})
      else
        this.$router.push({ name: this.pageSettings.sectionName + '.index' })
    },
    addItem() {
      this.$router.push({ name: this.pageSettings.sectionName + '.create' })
    },
    exportData,
    importData,
    allowView(item) {
      return this.hasPermission('read product')
    },
    allowEdit(item) {
      return this.hasPermission('update product')
    },
    allowDelete(item) {
      return this.hasPermission('delete product')
    },
    hasContextMenu(item) {
      return this.allowView(item) || this.allowEdit(item) || this.allowDelete(item)
    },
    customRowStyle(item) {
      let style = {}
      if( item.standard )
        style['font-weight'] = 'bold'

      if( item.vendor_project_status === 'EOL' )
        style['background-color'] = '#ff6b6b'
      
      return style
    },
    reload() {
      this.$refs.datatable.reload()
    }
  }
}
</script>
<style>
</style>